/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelItemMinimalWithVisibilityMetadataListResponse } from '../../models/travel-item-minimal-with-visibility-metadata-list-response';

export interface TravelControllerGetTourLeaderTravels$Params {
  idTourLeader: number;
  categories?: Array<number>;
  tour_leaders?: Array<number>;
  countries?: Array<string>;
  from_date?: string;
  to_date?: string;
  query?: string;
  price_from?: number;
  price_to?: number;
  with_flights?: boolean;
  show_past_travels?: boolean;
  sort_by?: string;
  limit: number;
  skip: number;
}

export function travelControllerGetTourLeaderTravels(http: HttpClient, rootUrl: string, params: TravelControllerGetTourLeaderTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetTourLeaderTravels.PATH, 'get');
  if (params) {
    rb.path('idTourLeader', params.idTourLeader, {});
    rb.query('categories', params.categories, {});
    rb.query('tour_leaders', params.tour_leaders, {});
    rb.query('countries', params.countries, {});
    rb.query('from_date', params.from_date, {});
    rb.query('to_date', params.to_date, {});
    rb.query('query', params.query, {});
    rb.query('price_from', params.price_from, {});
    rb.query('price_to', params.price_to, {});
    rb.query('with_flights', params.with_flights, {});
    rb.query('show_past_travels', params.show_past_travels, {});
    rb.query('sort_by', params.sort_by, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
      }>;
    })
  );
}

travelControllerGetTourLeaderTravels.PATH = '/travel/organized-travels/{idTourLeader}';
